import { createStoreAPI } from './CreateStoreAPIService'

export const getLinksUploadArtwork = (params) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return process.env.REACT_APP_NEXT_MOCKUP_GENERATOR_SERVICE
        },
        timeout: 600000,
    })
    return api.makeAuthRequest({
        url: `/file/presigned-url`,
        method: 'GET',
        params,
    })
}

export const getLinksUploadBackground = (params) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return process.env.REACT_APP_NEXT_MOCKUP_GENERATOR_SERVICE
        },
        timeout: 600000,
    })
    return api.makeAuthRequest({
        url: `/mockup-background/presigned-url`,
        method: 'GET',
        params,
    })
}

export const verifyUploadBackground = (payload) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return process.env.REACT_APP_NEXT_MOCKUP_GENERATOR_SERVICE
        },
        timeout: 600000,
    })
    return api.makeAuthRequest({
        url: `/mockup-background/verify-upload`,
        method: 'POST',
        data: payload,
    })
}

export const downloadMockup = (payload) => {
    const api = createStoreAPI({
        getBaseURL: () => {
            return process.env.REACT_APP_NEXT_MOCKUP_GENERATOR_SERVICE
        },
        timeout: 600000,
    })
    return api.makeAuthRequest({
        url: `/mockup-preview/download`,
        method: 'POST',
        data: payload,
    })
}

export const uploadTempArtwork = (url, image, contentType = 'image/png', setProgress) => {
    const api = createStoreAPI({
        timeout: 600000,
    })

    return api.makePublicRequest({
        url,
        method: 'PUT',
        data: image, // Binary
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        headers: {
            'Content-Type': contentType,
        },
        onUploadProgress: (progressEvent) => {
            if (typeof setProgress !== 'function') return
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setProgress(percentCompleted)
        },
    })
}

export const getArtworkFonts = () => {
    const api = createStoreAPI({ suffix: '/artwork/artwork-templates', timeout: 180000 })
    return api.makeAuthRequest({
        url: `/fonts`,
        method: 'GET',
    })
}

export const uploadArtworkFonts = (formData) => {
    const api = createStoreAPI({ suffix: '/artwork/artwork-templates', timeout: 180000 })
    return api.makeAuthRequest({
        url: '/fonts',
        method: 'POST',
        data: formData,
    })
}

export const uploadArtworkMultiFonts = (formData) => {
    const api = createStoreAPI({ suffix: '/artwork/artwork-templates', timeout: 180000 })
    return api.makeAuthRequest({
        url: '/fonts/multi',
        method: 'POST',
        data: formData,
    })
}

export const getUsageCapacity = () => {
    const api = createStoreAPI({ suffix: '/artwork' })
    return api.makeAuthRequest({
        url: `/design-images/storage`,
        method: 'GET',
    })
}

export const uploadDesignLibrary = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => `https://bost-group-0-1.merchize.com/ed8tdm9/bo-api/artwork`,
        suffix: '/artwork', timeout: 180000
    })
    return api.makeAuthRequest({
        url: '/design-images',
        method: 'POST',
        data,
    })
}

/**
 * @typedef {'mockup'|'custom_shape'} DesignTemplateTypeEnum
 */

/**
 * @typedef {Object} TemplateData
 * @property {string} name - The name of the template.
 * @property {string} preview_image - The URL of the preview image.
 * @property {string} description - The description of the template.
 *
 * @property {number} width - The width of the template.
 * @property {number} height - The height of the template.
 * @property {any[]} layers - The layers included in the template.
 * @property {string} data - The document data of the template - This property is used to save the document data of side cute editor.
 * @property {string} description - The description of the template.
 * @property {DesignTemplateTypeEnum} [type='mockup'] - The type of the template.
 */

/**
 * @param {TemplateData} data
 * @returns {*}
 */
export const uploadDesignLibraryTemplate = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => `https://bost-group-0-1.merchize.com/ed8tdm9/bo-api/product`,
        suffix: '/product', timeout: 180000
    })
    return api.makeAuthRequest({
        url: '/artwork-template',
        method: 'POST',
        data,
    })
}

export const getListDesignLibraryTemplate = (params) => {
    const api = createStoreAPI({ suffix: '/product', timeout: 180000 })
    return api.makeAuthRequest({
        url: '/artwork-template',
        method: 'GET',
        params: {
            ...params,
            type: 'mockup'
        },
    })
}
export const getListCustomShapeTemplate = (params) => {
    const api = createStoreAPI({suffix: '/product', timeout: 180000})
    return api.makeAuthRequest({
        url: '/artwork-template',
        method: 'GET',
        params: {
            ...params,
            type: 'custom_shape',
        },
    })
}


export const updateCustomShapeTemplate = (data) => {
    const api = createStoreAPI({
        getBaseURL: () => `https://bost-group-0-1.merchize.com/ed8tdm9/bo-api/product`,
        suffix: '/product',
        timeout: 180000,
    })
    return api.makeAuthRequest({
        url: `/artwork-template/${data.id}`,
        method: 'PUT',
        data,
    })
}


export const deleteDesignLibraryTemplate = (id) => {
    const api = createStoreAPI({ suffix: '/product', timeout: 180000 })
    return api.makeAuthRequest({
        url: `/artwork-template/${id}`,
        method: 'DELETE',
    })
}

export const getDesignLibraryImage = (imageId) => {
    const api = createStoreAPI({
        getBaseURL: () => `https://bost-group-0-1.merchize.com/ed8tdm9/bo-api/artwork`,
        suffix: '/artwork'
    })
    return api.makeAuthRequest({
        url: `/design-images/${imageId}`,
        method: 'GET',
    })
}

export const getListDesignLibrary = (params) => {
    const api = createStoreAPI({
        getBaseURL: () => `https://bost-group-0-1.merchize.com/ed8tdm9/bo-api/artwork`,
        suffix: '/artwork'
    })
    return api.makeAuthRequest({
        url: `/design-images`,
        method: 'GET',
        params,
    })
}

export const deleteDesignLibraryImage = (imageId) => {
    const api = createStoreAPI({ suffix: '/artwork' })
    return api.makeAuthRequest({
        url: `/design-images/${imageId}`,
        method: 'DELETE',
    })
}

export const getVariantArtworks = (productId, options = []) => {
    const api = createStoreAPI({ suffix: '/artwork' })
    return api.makeAuthRequest({
        url: `artworks/product/${productId}/variant/artworks`,
        method: 'POST',
        data: {
            options,
        },
    })
}

export const getProductArtworks = (productId, options = []) => {
    const api = createStoreAPI({suffix: '/artwork'})
    return api.makeAuthRequest({
        url: `artworks?product=${productId}`,
        method: 'GET',
    })
}

export const createArtworksForVariant = (productId, payload) => {
    const api = createStoreAPI({ suffix: '/artwork' })
    return api.makeAuthRequest({
        url: `artworks/product/${productId}/variant`,
        method: 'POST',
        data: payload,
    })
}

export const uploadTempArtworkVariant = (data, setProgress, byLink = false) => {
    const api = createStoreAPI({
        suffix: '/artwork',
        timeout: 600000,
        onUploadProgress: (progressEvent) => {
            if (typeof setProgress !== 'function') return
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            if (percentCompleted < 10 || percentCompleted % 20 === 0) {
                setProgress(percentCompleted)
            }
        },
    })
    if (byLink) {
        return api.makeAuthRequest({
            url: '/artworks/variant/temp/by-link',
            method: 'POST',
            data,
        })
    }
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
    })

    return api.makeAuthRequest({
        url: '/artworks/variant/temp',
        method: 'POST',
        data: formData,
    })
}
